import { Button, Loader } from "@/components";
import { useResubscribeURL } from "@/hooks";
import { CloseMD } from "@/icons";
import { useResponsiveness, useTranslate } from "@/providers/context";
import { RESUBSCRIBE_BANNER_HEIGHT } from "@/const";

export const ResubscribeBanner = () => {
  const { translate } = useTranslate();
  const resubscribeURL = useResubscribeURL();
  const { setResubscribeBannerDismissed } = useResponsiveness();

  const handleAddPaymentDetails = () => {
    resubscribeURL.mutate(undefined, {
      onSuccess: (url) => {
        if (url) {
          window.location.href = url;
        }
      },
      onError: (error) => {
        console.error("Failed to get resubscribe URL:", error);
      },
    });
  };

  return (
    <div
      className="p1-semibold relative flex w-full items-center justify-center bg-alert-surface"
      style={{ height: RESUBSCRIBE_BANNER_HEIGHT }}
    >
      <div>
        {translate(
          "Please add your payment details to continue your subscription.",
        )}{" "}
        <span
          className="relative cursor-pointer underline underline-offset-2 hover:text-item-secondary active:text-item-primary"
          onClick={handleAddPaymentDetails}
        >
          {`${translate("Add Payment Details")} →`}
          {resubscribeURL.isLoading && (
            <div className="absolute -right-5 top-1/2 -translate-y-1/2">
              <Loader />
            </div>
          )}
        </span>
      </div>
      <Button
        onClick={() => setResubscribeBannerDismissed(true)}
        size="s"
        variant="tertiary"
        className="absolute right-[18px] top-1/2 -translate-y-1/2 !bg-transparent"
        icon={<CloseMD height={24} width={24} />}
      />
    </div>
  );
};
